import PropTypes from "prop-types";

function getTranslatedRole(role, t) {
  const normalizedRole = String(role || "")
    .toLowerCase()
    .replace(/\s+/g, "")
    .replace(/_/g, "");

  if (normalizedRole === "superadmin" || normalizedRole === "superadministrator") {
    return t ? t("navigation.superAdmin", "Super Admin") : "Super Admin";
  }
  if (normalizedRole === "admin") {
    return t ? t("navigation.admin", "Admin") : "Admin";
  }
  if (normalizedRole === "annotator") {
    return t ? t("navigation.annotator", "Annotator") : "Annotator";
  }
  return role || "-";
}

export default function DeletedUsersDataTable({ users, t }) {
  // Define columns with translation support
  const columns = [
    {
      Header: t ? t("superAdmin.table.columns.name", "Name") : "Name",
      accessor: "first_name",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: t ? t("superAdmin.table.columns.role", "Role") : "Role",
      accessor: "role",
      Cell: ({ value }) => getTranslatedRole(value, t),
    },
    {
      Header: t ? t("superAdmin.table.columns.phoneNumber", "Phone Number") : "Phone Number",
      accessor: "phone_number",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: t ? t("superAdmin.table.columns.email", "Email") : "Email",
      accessor: "email_id",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: t ? t("superAdmin.table.columns.state", "State") : "State",
      accessor: "state",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: t ? t("superAdmin.table.columns.district", "District") : "District",
      accessor: "district",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: t ? t("superAdmin.table.columns.createdBy", "Created By") : "Created By",
      accessor: "created_by",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: t ? t("superAdmin.table.columns.deletedBy", "Deleted By") : "Deleted By",
      accessor: "deleted_by",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: t ? t("superAdmin.table.columns.deletedAt", "Deleted At") : "Deleted At",
      accessor: "deleted_date",
      Cell: ({ value }) => {
        if (!value) return "-";
        const date = new Date(value);
        return date.toLocaleString();
      },
    },
  ];

  // Process rows data
  const rows = users.map((user) => ({
    ...user,
  }));

  return {
    columns,
    rows,
  };
}

DeletedUsersDataTable.propTypes = {
  users: PropTypes.array.isRequired,
  t: PropTypes.func,
};

DeletedUsersDataTable.defaultProps = {
  t: null,
};
